// Angular
import {NgModule} from '@angular/core';
import {RouterModule, Routes, PreloadAllModules} from '@angular/router';
// Components
import {BaseComponent} from './views/theme/base/base.component';
import {ErrorPageComponent} from './views/theme/content/error-page/error-page.component';
// Auth


// NOTE: HrmsModule is lazy-loaded in routes, so we do not import it here to keep bundles smaller.
// import { HrmsModule } from './views/pages/Hrms/hrms.module';
// import{ADM0050Component} from './views/pages/Hrms/hrms/Pages/adm0050/adm0050.component';

const routes: Routes = [
	{path: 'widget', loadChildren: () => import('app/views/pages/widget/widget.module').then(m => m.WidgetModule)},

	{path: 'auth', loadChildren: () => import('app/views/pages/auth/auth.module').then(m => m.AuthModule)},

	{
		path: '',
		component: BaseComponent,
		//canActivate: [AuthGuard],
		children: [
			{
				path: 'dashboard',
				loadChildren: () => import('app/views/pages/dashboard/dashboard.module').then(m => m.DashboardModule),
			},
			
			// {
			// 	path:'ADM0050',
			// 	component:ADM0050Component
			// },
			{
				// path:'hrms',
				// loadChildren:()=>('app/views/pages/Hrms/hrms.module').then(m=>m.HrmsModule),

				path: 'hrms',
				loadChildren: () => import('app/views/pages/Hrms/hrms.module').then(m => m.HrmsModule),
		    },
			{
				// path:'hrms',
				// loadChildren:()=>('app/views/pages/Hrms/hrms.module').then(m=>m.HrmsModule),

				path: 'einvoice',
				loadChildren: () => import('app/views/pages/Einvoice/einvoice.module').then(m => m.EinvoiceModule),
		    },
			{
				path: 'mail',
				loadChildren: () => import('app/views/pages/apps/mail/mail.module').then(m => m.MailModule),
			},
			{
				path: 'ecommerce',
				loadChildren: () => import('app/views/pages/apps/e-commerce/e-commerce.module').then(m => m.ECommerceModule),
			},
			{
				path: 'ngbootstrap',
				loadChildren: () => import('app/views/pages/ngbootstrap/ngbootstrap.module').then(m => m.NgbootstrapModule),
			},
			{
				path: 'material',
				loadChildren: () => import('app/views/pages/material/material.module').then(m => m.MaterialModule),
			},
			
			{
				path: 'wizard',
				loadChildren: () => import('app/views/pages/wizard/wizard.module').then(m => m.WizardModule),
			},
			{
				path: 'builder',
				loadChildren: () => import('app/views/theme/content/builder/builder.module').then(m => m.BuilderModule),
			},
			{
				path: 'error/403',
				component: ErrorPageComponent,
				data: {
					type: 'error-v6',
					code: 403,
					title: '403... Access forbidden',
					desc: 'Looks like you don\'t have permission to access for requested page.<br> Please, contact administrator',
				},
			},
			{path: 'error/:type', component: ErrorPageComponent},
			{path: '', redirectTo: 'dashboard', pathMatch: 'full'},
			{path: '**', redirectTo: 'dashboard', pathMatch: 'full'},
		],
	},

	{path: '**', redirectTo: 'error/403', pathMatch: 'full'},
];

@NgModule({
	imports: [
		//RouterModule.forRoot(routes),
		RouterModule.forRoot(routes, {
			useHash: true,
			preloadingStrategy: PreloadAllModules,
		}),
	],
	exports: [RouterModule],
})
export class AppRoutingModule {
}
